import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

Sentry.init({
  dsn: "https://3a0125b42dd9403ed4f6aa163c6e95fc@o4510018714140672.ingest.us.sentry.io/4511023392948224",
  sendDefaultPii: true,
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,
});

createRoot(document.getElementById("root")!).render(<App />);
